import { render, staticRenderFns } from "./LoginSpid.vue?vue&type=template&id=65caade3"
import script from "./LoginSpid.vue?vue&type=script&lang=js"
export * from "./LoginSpid.vue?vue&type=script&lang=js"
import style0 from "./LoginSpid.vue?vue&type=style&index=0&id=65caade3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports